import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useLoyalty, useTheme } from '../../../../hooks';
import { mashupRewardItems } from "../data";

const useTriviaOrders = () => {
  const [order, setOrder] = useState();
  const [item, setItem] = useState();

  const { themeContext, theme } = useTheme();
  const { mashupnWinOrders } = useLoyalty();

  const history = useHistory();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const getOrder = (orderId) => {
    if (Array.isArray(mashupnWinOrders)) {
      const foundOrder = mashupnWinOrders.find(orderData => orderData.orderId === orderId);
      const { itemId } = foundOrder || {};
      const foundItem = mashupRewardItems.find(({ id }) => id === itemId)
      setOrder(foundOrder);
      setItem(foundItem);
    }
  }

  return {
    background,
    history,
    mashupnWinOrders,
    mashupRewardItems,
    order,
    setOrder,
    item,
    setItem,
    getOrder,
    unitPoints: 50,
  }
}

export default useTriviaOrders